import {LayoutGrid,BriefcaseBusiness,Target,Rows4,ListTodo,StickyNote,ClipboardList,CircleUserRound,FolderKanban,Boxes,DoorClosed} from "lucide-vue-next";
export const links = [
    {
        path: "/",
        icon: LayoutGrid,
        label: "Tableau de bord",
        isUnique: true,
        id: "box1",
        subList: []
    },
    {
        path: "",
        icon: Target,
        label: "Attendance",
        isUnique: false,
        id: "box2",
        subList: [
            {
                path: "/my-exceptions",
                label: "Mes exception"
            },
            {
                path: "/my-perms",
                label: "Mes permissions"
            }
        ]
    },
    {
        path: "",
        icon: ClipboardList,
        label: "Mes tâches",
        isUnique: false,
        id: "box3",
        subList: [
            {
                path: "/my-permissions",
                label: "Mes requêtes"
            },
            {
                path: "/list-exit",
                label: "Exit"
            },
            {
                path: "/my-preview",
                label: "Gestion congé"
            }
        ]
    },
    {
        path: "/my-demande",
        icon: StickyNote,
        label: "Mes Demandes",
        isUnique: true,
        id: "box7",
        subList: []
    },
    {
        path: "/task",
        icon: ListTodo,
        label: "Mes objectifs",
        isUnique: true,
        id: "box8",
        subList: []
    },
    {
        path: "/my-profile",
        icon: CircleUserRound,
        label: "Mon Profil",
        isUnique: true,
        id: "box5",
        subList: []
    },
    {
        path: "",
        icon: FolderKanban,
        label: "Gestion",
        isUnique: false,
        id: "box4",
        subList: [
            {
                path: "/presences",
                label: "Présences"
            },
            {
                path: "/exceptions",
                label: "Exceptions"
            },
            {
                path: "/requetes",
                label: "Requêtes"
            },
            {
                path: "/payroll",
                label: "Payroll"
            }

        ]
    },
    {
        path: "/offer",
        icon: BriefcaseBusiness,
        label: "Offres",
        isUnique: true,
        id: "box10",
        subList: []
    },
    {
        path: "/hr-review",
        icon: Rows4,
        label: "Performance",
        isUnique: true,
        id: "box9",
        subList: []
    },
    {
        path: "",
        icon: Boxes,
        label: "Ressource",
        isUnique: false,
        id: "box5",
        subList: [
            {
                path: "/employes",
                label: "Employées"
            },
            // {
            //     path: "/validateur",
            //     label: "Validateurs"
            // },
            {
                path: "/profils",
                label: "Profils"
            },
            {
                path: "/departements",
                label: "Départements"
            },
            {
                path: "/documents",
                label: "Documents"
            },
            {
                path: "/motifs",
                label: "Motifs"
            },
            {
                path: "/shifts",
                label: "Horaires"
            },
            {
                path: "/joursautorises",
                label: "Jours autorisées"
            }
        ]
    },
    {
        path: "",
        icon: DoorClosed,
        label: "Sécurité",
        isUnique: false,
        id: "box6",
        subList: [
            {
                path: "/access",
                label: "Accès"
            },
            {
                path: "/zonesautorisees",
                label: "Zones autorisées"
            }
        ]
    }
]